/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SetupModeButton_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdvancedSettingsV5_organization$ref: FragmentReference;
declare export opaque type AdvancedSettingsV5_organization$fragmentType: AdvancedSettingsV5_organization$ref;
export type AdvancedSettingsV5_organization = {|
  +id: string,
  +name: string,
  +$fragmentRefs: SetupModeButton_organization$ref,
  +$refType: AdvancedSettingsV5_organization$ref,
|};
export type AdvancedSettingsV5_organization$data = AdvancedSettingsV5_organization;
export type AdvancedSettingsV5_organization$key = {
  +$data?: AdvancedSettingsV5_organization$data,
  +$fragmentRefs: AdvancedSettingsV5_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdvancedSettingsV5_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SetupModeButton_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '9d7b24e651b8a61d96e9c092d791a965';

module.exports = node;
